import type { TaskHistoryQuery } from '@/types/provisioning';

/** Centralized TanStack Query keys for the Provisioning API. */
export const provisioningKeys = {
  all: ['provisioning'] as const,
  playbooks: () => ['provisioning', 'playbooks'] as const,
  playbook: (id: number) => ['provisioning', 'playbook', id] as const,
  task: (taskId: number) => ['provisioning', 'task', taskId] as const,
  taskHistory: (query: TaskHistoryQuery) => ['provisioning', 'tasks', query] as const,
};
